import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ISiteBoxDocumentConfigResult } from '@core/entities/SiteBoxDocumentConfig'

export const useUpdateQueryAppraisal = (
  options?: UseMutationOptions<
    ISiteBoxDocumentConfigResult,
    RequestErrorType,
    RequestTypes['updateQueryAppraisal']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...siteBoxDocumentsKeys.updateQueryAppraisal,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byConfigId._def,
      })
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({
          documentId: variables.documentId,
        }).queryKey,
      })
      options?.onSuccess?.(data, variables, context)
    },
  })
}
